// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EmptyTexte_content__1rhO3 {\n  width: 100%;\n  margin-top: 1rem;\n  text-align: center;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Misc/EmptyTexte.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".content {\n  width: 100%;\n  margin-top: 1rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "EmptyTexte_content__1rhO3"
};
export default ___CSS_LOADER_EXPORT___;
